import { getOrders, deleteOrder } from '../../api/orders';

const state = {
    list: [],
    pageSize: 20,
    totalCount: 0
}

const getters = {
    getList( state ) {
       return state.list;
    }
}

const mutations = {
    SET_LIST(state, data) {
       state.list = data;
    },

    SET_PARAMS(state, data){
        state.pageSize = data.perPage;
        state.totalCount = data.total;
    },

    DELETE_LIST(state, id) {
        let index = state.list.findIndex(item => item.id === id);
        state.list.splice(index, 1)
    },
}

const actions = {
    list({ dispatch, commit }, load) {
        return new Promise( (resolve, reject) => {
            let params = {
                pageSize: state.pageSize,
                page: 1
            }

            if(load && state.pageSize < state.totalCount){
                params.pageSize = state.pageSize + 20;
            }

            getOrders(params).then(res => {
                if(res.data){
                    commit('SET_LIST', res.data.dataProvider.items);
                    
                    commit('SET_PARAMS', { perPage: parseInt(res.data.dataProvider._meta.perPage), total: parseInt(res.data.dataProvider._meta.totalCount) });

                    resolve();
                }

            }).catch(error => {
                console.log(error);
                dispatch('Common/setError', error.data, { root: true });
                
                reject(error);
            });
        })
    },

    remove({ dispatch, commit }, id) {
        let bodyFormData = new FormData();
        
        return new Promise( (resolve, reject) => {
            deleteOrder(id, bodyFormData).then(res => {
                dispatch('Common/setSuccess', 'Order closed', { root: true });
                dispatch('list');
                resolve();

            }).catch(error => {
                console.log(error);
                dispatch('Common/setError', error.data, { root: true });
                dispatch('list');
                reject(error);
            });
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}